import React from "react";
import "./SalePopup4.scss";
import { useLocalStorage } from "../../../shared/utill";
import { format } from "date-fns";

const SALE_POPUP_STORAGE_KEY = "salePopup4ClosedDate";

const SalePopup4 = () => {
  const nowDate = format(new Date(), "yyyy-MM-dd");
  const [isTodayClosed, setIsTodayClosed] = useLocalStorage(
    SALE_POPUP_STORAGE_KEY,
    {
      nowDate: "",
    }
  );
  const [closeToday, setCloseToday] = React.useState(false);
  const [isOpen, setIsOpen] = React.useState(
    () => isTodayClosed.nowDate !== nowDate
  );

  const toggleCloseToday = React.useCallback(() => {
    setCloseToday((prev) => !prev);
  }, []);

  const close = React.useCallback(() => {
    if (closeToday) {
      setIsTodayClosed({ nowDate });
    }
    setIsOpen(false);
  }, [closeToday, setIsTodayClosed, nowDate]);

  const onOverlayClick = React.useCallback(
    (event: React.MouseEvent<HTMLDivElement>) => {
      if (event.target === event.currentTarget) {
        close();
      }
    },
    [close]
  );

  if (!isOpen) {
    return null;
  }

  return (
    <div className="sale-popup4-wrap" onClick={onOverlayClick}>
      <div className="sale-popup4">
        <a href="/consult3" className="sale-popup4__link">
          <img
            className="sale-popup4__image"
            src={require("../../../static/popup-260721.png")}
            alt="웰컴혜택 반값 프로모션 - 50% SALE"
          />
        </a>
        <div className="sale-popup4__bottom-area">
          <button
            type="button"
            className={`sale-popup4__close-today ${closeToday ? "active" : ""}`}
            onClick={toggleCloseToday}
          >
            {closeToday ? (
              <svg
                className="sale-popup4__checkbox"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                aria-hidden="true"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M2.25 12C2.25 6.615 6.615 2.25 12 2.25C17.385 2.25 21.75 6.615 21.75 12C21.75 17.385 17.385 21.75 12 21.75C6.615 21.75 2.25 17.385 2.25 12ZM15.61 10.186C15.67 10.1061 15.7134 10.0149 15.7377 9.91795C15.762 9.82098 15.7666 9.72014 15.7514 9.62135C15.7361 9.52257 15.7012 9.42782 15.6489 9.3427C15.5965 9.25757 15.5276 9.18378 15.4463 9.12565C15.3649 9.06753 15.2728 9.02624 15.1753 9.00423C15.0778 8.98221 14.9769 8.97991 14.8785 8.99746C14.7801 9.01501 14.6862 9.05205 14.6023 9.10641C14.5184 9.16077 14.4462 9.23135 14.39 9.314L11.154 13.844L9.53 12.22C9.38783 12.0875 9.19978 12.0154 9.00548 12.0188C8.81118 12.0223 8.62579 12.101 8.48838 12.2384C8.35097 12.3758 8.27225 12.5612 8.26882 12.7555C8.2654 12.9498 8.33752 13.1378 8.47 13.28L10.72 15.53C10.797 15.6069 10.8898 15.6662 10.992 15.7036C11.0942 15.7411 11.2033 15.7559 11.3118 15.7469C11.4202 15.738 11.5255 15.7055 11.6201 15.6519C11.7148 15.5982 11.7967 15.5245 11.86 15.436L15.61 10.186Z"
                  fill="#006AFF"
                />
              </svg>
            ) : (
              <svg
                className="sale-popup4__checkbox"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                aria-hidden="true"
              >
                <path
                  d="M9 12.75L11.25 15L15 9.75M21 12C21 13.1819 20.7672 14.3522 20.3149 15.4442C19.8626 16.5361 19.1997 17.5282 18.364 18.364C17.5282 19.1997 16.5361 19.8626 15.4442 20.3149C14.3522 20.7672 13.1819 21 12 21C10.8181 21 9.64778 20.7672 8.55585 20.3149C7.46392 19.8626 6.47177 19.1997 5.63604 18.364C4.80031 17.5282 4.13738 16.5361 3.68508 15.4442C3.23279 14.3522 3 13.1819 3 12C3 9.61305 3.94821 7.32387 5.63604 5.63604C7.32387 3.94821 9.61305 3 12 3C14.3869 3 16.6761 3.94821 18.364 5.63604C20.0518 7.32387 21 9.61305 21 12Z"
                  stroke="#B7BEC7"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            )}
            오늘 하루 보지 않기
          </button>
          <button type="button" className="sale-popup4__close" onClick={close}>
            닫기
          </button>
        </div>
      </div>
    </div>
  );
};

export default SalePopup4;
